var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { TokenClient } from '../../../../../../services/authentication/token-client.service';
import { NotificationClientService, NotificationType } from '../../../../../../services/basics/notification-client.service';
import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { ClientLotteryClientService } from '../../../../../../services/modules/client/client-lottery-client-service';
import { DialogClientService } from '../../../../../../services/basics/dialog-client.service';
import { BindingSignaler } from 'aurelia-templating-resources';
import { BaseChooseTickets } from '../../../base-choose-tickets';
import { MobileHelper } from '../../../../../../helpers/mobile-helper';
import * as Enumerable from "linq";
import { GamePlayerTicketClientService } from '../../../../../../services/modules/client/client-game-player-ticket-client.service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { customElement } from '../../../../../../../../node_modules/aurelia-framework';
var QuickPlayChooseTickets = /** @class */ (function (_super) {
    __extends(QuickPlayChooseTickets, _super);
    function QuickPlayChooseTickets(router, tokenClient, gamePlayerTicketClientService, bindingSignaler, notificationClientService, i18N, lotteryClientService, eventAggregator, dialogClientService, element) {
        return _super.call(this, router, tokenClient, gamePlayerTicketClientService, bindingSignaler, notificationClientService, i18N, lotteryClientService, eventAggregator, dialogClientService, element) || this;
    }
    QuickPlayChooseTickets.prototype.getTicketsPerLine = function () {
        return 4;
    };
    QuickPlayChooseTickets.prototype.loadSavedTickets = function () {
        this.isLoadingTickets = false;
        this.setTickets([]);
        this.bindingSignaler.signal('refresh-add-lines');
        this.updateTicketNumbers();
        this.checkSubscribeAndDefaultDiscount();
        this.onLotteryDetailsLoaded();
    };
    QuickPlayChooseTickets.prototype.onLotteryDetailsLoaded = function () {
        var _this = this;
        var tickets = Enumerable.from(this.tickets)
            .count(function (x) { return _this.getRemainingBonus(x) == 0 && _this.getRemainingMain(x) == 0; });
        if (!MobileHelper.isMobileDevice() && !this.cartGuid && tickets == 0) {
            this.pickOne();
            this.pickOne();
            this.pickOne();
            this.pickOne();
        }
    };
    QuickPlayChooseTickets.prototype.pickRandom = function (ticket) {
        this.pickRandomInternal(ticket);
    };
    QuickPlayChooseTickets.prototype.shouldScrollTopOnLoad = function () {
        return false;
    };
    QuickPlayChooseTickets.prototype.onAddedToCart = function () {
        this.onLotteryDetailsLoaded();
    };
    QuickPlayChooseTickets.prototype.onPurchase = function () {
        this.onLotteryDetailsLoaded();
    };
    QuickPlayChooseTickets.prototype.editOne = function () {
        var firstTicketWithNoPicks = this.getFirstTicket();
        if (firstTicketWithNoPicks == null)
            this.addLines();
        this.isFirstTime = false;
        this.ticketInEdit = firstTicketWithNoPicks == null ? this.getFirstTicket() : firstTicketWithNoPicks;
    };
    QuickPlayChooseTickets.prototype.editTicket = function (ticket) {
        this.isFirstTime = false;
        this.ticketInEdit = ticket;
    };
    QuickPlayChooseTickets.prototype.validateRequest = function (request) {
        var draws = Enumerable.from(this.discountOffers).any();
        if (!draws) {
            this.notificationClientService.show(this.i18n.tr("no-draws-set-up"), "", NotificationType.Warning);
            return false;
        }
        else if (request && request.draws <= 0) {
            this.notificationClientService.show(this.i18n.tr("select-draw-number"), "", NotificationType.Warning);
            return false;
        }
        else if (!this.ticketPrice) {
            this.notificationClientService.show(this.i18n.tr("prices-not-set-for-your-currency"), "", NotificationType.Warning);
            return false;
        }
        return true;
    };
    QuickPlayChooseTickets.prototype.noTicketsToPurchase = function () {
        this.notificationClientService.show(this.i18n.tr("no-tickets-to-purchase"), "", NotificationType.Warning);
    };
    QuickPlayChooseTickets.prototype.updatedCart = function () {
        this.notificationClientService.show(this.i18n.tr("updated-cart"), "", NotificationType.Success);
    };
    QuickPlayChooseTickets.prototype.noTicketsAddedToCart = function () {
        this.notificationClientService.show(this.i18n.tr("no-tickets-to-add-to-cart"), "", NotificationType.Warning);
    };
    QuickPlayChooseTickets.prototype.ticketsAddedToCart = function () {
        this.notificationClientService.show(this.i18n.tr("tickets-added-to-cart"), "", NotificationType.Success);
    };
    QuickPlayChooseTickets = __decorate([
        autoinject,
        customElement('quick-play-choose-tickets'),
        transient(),
        __metadata("design:paramtypes", [Router, TokenClient, GamePlayerTicketClientService, BindingSignaler,
            NotificationClientService, I18N, ClientLotteryClientService, EventAggregator,
            DialogClientService, Element])
    ], QuickPlayChooseTickets);
    return QuickPlayChooseTickets;
}(BaseChooseTickets));
export { QuickPlayChooseTickets };
